<template>
  <div class="wage-status">
    <div class="month-grid">
      <div 
        v-for="month in 12" 
        :key="month"
        class="month-item"
        :class="getMonthStatus(month)"
        @click="handleMonthClick(month)"
      >
        <span class="month-num">{{ month }}</span>
        <span class="month-label">월</span>
        <div class="month-indicator">
          <v-icon size="12" v-if="getMonthStatus(month) === 'closed'" color="white">mdi-check</v-icon>
          <v-icon size="12" v-else-if="getMonthStatus(month) === 'progress'" color="white">mdi-dots-horizontal</v-icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';

const props = defineProps<{
  selectedYear: number;
}>();

const store = useStore();
const router = useRouter();

const wageMagamData = ref<any[]>([]);

// 월별 상태 가져오기
const getMonthStatus = (month: number): 'closed' | 'progress' | 'pending' => {
  const ym = `${props.selectedYear}${String(month).padStart(2, '0')}`;
  
  const monthData = wageMagamData.value.find(
    item => item.wm_job_type === '전체합계' && item.wm_ym === ym
  );
  
  if (!monthData) {
    // 현재 월까지만 '미시작', 그 이후는 '미래'
    const now = new Date();
    if (props.selectedYear > now.getFullYear()) return 'pending';
    if (props.selectedYear === now.getFullYear() && month > now.getMonth() + 1) return 'pending';
    return 'pending';
  }
  
  return monthData.wm_isuse === 'y' ? 'closed' : 'progress';
};

// 월 클릭 핸들러
const handleMonthClick = (month: number) => {
  const ym = `${props.selectedYear}${String(month).padStart(2, '0')}`;
  router.push(`/pwa/payroll?ym=${ym}`);
};

// 데이터 조회
const fetchData = async () => {
  try {
    const user = store.state.user;
    if (!user?.m_sisul_code) return;

    const response = await axios.get(
      `/api/calc/wage-magam-yearly/${user.m_sisul_code}/${props.selectedYear}`,
      { withCredentials: true }
    );

    if (response.data.success) {
      wageMagamData.value = response.data.data || [];
    }
  } catch (error) {
    console.error('임금 마감 데이터 조회 오류:', error);
  }
};

onMounted(() => {
  fetchData();
});

watch(() => props.selectedYear, () => {
  fetchData();
});
</script>

<style scoped lang="scss">
.wage-status {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  margin-bottom: 12px;

  .month-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 6px;
  }

  .month-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px 4px;
    border-radius: 8px;
    background: #f5f5f5;
    cursor: pointer;
    transition: all 0.2s;

    &:active { transform: scale(0.95); }

    .month-num {
      font-size: 14px;
      font-weight: 700;
      color: #333;
    }

    .month-label {
      font-size: 10px;
      color: #999;
    }

    .month-indicator {
      position: absolute;
      top: 4px;
      right: 4px;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &.closed {
      background: linear-gradient(135deg, #059669, #10b981);
      
      .month-num, .month-label { color: #fff; }
      .month-indicator { background: rgba(255,255,255,0.3); }
    }

    &.progress {
      background: linear-gradient(135deg, #f59e0b, #fbbf24);
      
      .month-num, .month-label { color: #fff; }
      .month-indicator { background: rgba(255,255,255,0.3); }
    }

    &.pending {
      background: #f0f0f0;
      
      .month-num { color: #bbb; }
      .month-label { color: #ccc; }
    }
  }
}
</style>














